<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Profile image' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <p>{{'Upload a new profile image' | translate}}</p>

    <div class="image-cropper image-cropper-profile image-cropper-profile-company">

      <div class="row">

        <div class="col-12 col-lg-6">

          <div class="image-cropper">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1"
            format="png"
            output="base64"
            [roundCropper]="true"
            (imageCropped)="imageCropped($event)"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
          ></image-cropper>
        </div>

        </div>

        <div class="col-12 col-lg-6">

          <div class="image-cropper-preview image-cropper-preview-circle">
            <img [src]="croppedImage" class="img-fluid" />
          </div>

        </div>

      </div>

      <div class="custom-file">
        <input type="file" class="custom-file-input" (change)="fileChangeEvent($event)"  id="avatarFile">
        <label class="custom-file-label" for="avatarFile" [attr.data-browse]="'Select file' | translate">{{'Upload a new profile image' | translate}}</label>
      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">
        <fa-icon *ngIf="isProcessing" [icon]="faSpinner" animation="spin"></fa-icon>
        {{'Save' | translate}}
      </button>
    </div>
  </div>
</div>
